import React, { useState, useRef } from 'react'
import { updateWinLossService } from '../../../services/winloss.service';
import { calculateAgentWinLoss } from '../../../utils/helper';

//toast
import { useDispatch } from 'react-redux';
import { setToastMessage } from "../../../reducers/common.reducer";

import {
    CircleMinus,
} from 'lucide-react';


const EditModal = (props) => {
    const { onClose, editData, setEditData } = props;

    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    let inputRef = useRef(null);
    const handleWheel = (event) => event.target.blur();

    const saveByRowAction = async () => {
        setIsLoading(true)
        try {
            let result;

            let editPayload = {
                winLossId: editData.winLossId,
                siteData: parseFloat(editData.siteData),
                winLoss: editData.winLoss ? Math.round(editData.winLoss) : 0,
                agentId: editData.agentId,
                userId: editData.userId
            }
            // console.log('editPayload', editPayload)
            result = await updateWinLossService(editPayload)
            // console.log(result);
            if (result) {
                dispatch(
                    setToastMessage({
                        message: "Success",
                        type: "success",
                    })
                );
                onClose(); 
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally { setIsLoading(false) }
    }

    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        const { winLoss } = calculateAgentWinLoss(editData, inputValue);
        setEditData(prev => ({ ...prev, siteData: inputValue, winLoss }));
    }

    const handleOnPaste = (e) => {
        e.preventDefault();
        const inputValue = e.clipboardData.getData("text");
        const { winLoss, commingValue } = calculateAgentWinLoss(editData, inputValue);
        setEditData(prev => ({ ...prev, siteData: commingValue, winLoss }));
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="w-full max-w-lg rounded-lg bg-white px-6 py-4 shadow-lg">
                <div className='flex justify-between items-center mb-10'>
                    <h2 className=" text-lg font-semibold text-gray-800">
                        {editData?.agentName}
                    </h2>
                    <CircleMinus size={20} onClick={onClose} />
                </div>

                <div className="space-y-2 text-sm text-gray-700">
                    <div className="flex justify-between">
                        <span>Site Data</span>
                        <div className=''>
                            <input
                                type="number"
                                inputMode="decimal"
                                ref={inputRef}
                                onWheel={handleWheel}
                                value={editData.siteData ? editData.siteData : ''}
                                onChange={handleInputChange}
                                onPaste={handleOnPaste}
                                className='bg-slate-200 max-w-72 w-full outline-none border-none rounded-md px-2 py-1.5 text-end text-gray-900 focus:ring-1 focus:ring-gray-400 focus:outline-none'
                            />
                        </div>
                    </div>

                    <div className="flex justify-between">
                        <span>Total Amount</span>
                        {/* <span className="font-medium">{totalAmount}</span> */}
                        <div className='px-6 rounded-md bg-slate-200 py-1.5 max-w-64 w-full text-end'>{editData?.winLoss ? Math.round(editData?.winLoss) : 0}</div>
                    </div>
                </div>

                <div className='flex justify-end mb-2'>
                    <button
                        onClick={saveByRowAction}
                        disabled={isLoading}
                        className={`mt-6 w-1/4 rounded-md py-2 text-white active:scale-[0.98] ${isLoading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
                    >
                        {isLoading ? 'Saving...' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditModal
